import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { ApiFragment, Identifier, ShBaseFormComponent } from '@stylehaven/components';

@Component({
    selector: 'med-form-thesaurus',
    templateUrl: './form-thesaurus.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormThesaurusComponent extends ShBaseFormComponent implements OnInit {
    @Input() thesaurusDefDottedKey: string;
    @Input() recordIds: Identifier[];
    @Input() enableSuggestions = false;
    @Input() multiple = false;
    @Input() initialSuggestions: string[];
    @Input() activeRecord?: ApiFragment;

    // Messages
    @Input() placeholderMsg?: string;
    @Input() suggestionExistsErrorMsg?: string;
    @Input() maxValuesMsg?: string;
    @Input() selectValuesLabel: string;
    @Input() declare disabledMsg?: string;

    ngOnInit(): void {
        super.ngOnInit();
    }
}
